/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Brightness_LabelInputs */

const en_video_filters_brightness_label = /** @type {(inputs: Video_Filters_Brightness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brightness`)
};

const fr_video_filters_brightness_label = /** @type {(inputs: Video_Filters_Brightness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminosite`)
};

const de_video_filters_brightness_label = /** @type {(inputs: Video_Filters_Brightness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helligkeit`)
};

const it_video_filters_brightness_label = /** @type {(inputs: Video_Filters_Brightness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminosità`)
};

const ru_video_filters_brightness_label = /** @type {(inputs: Video_Filters_Brightness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Яркость`)
};

const es_video_filters_brightness_label = /** @type {(inputs: Video_Filters_Brightness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brillo`)
};

const zh_cn2_video_filters_brightness_label = /** @type {(inputs: Video_Filters_Brightness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`亮度`)
};

const ja_video_filters_brightness_label = /** @type {(inputs: Video_Filters_Brightness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輝度`)
};

const hi_video_filters_brightness_label = /** @type {(inputs: Video_Filters_Brightness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चमक`)
};

const pt_pt2_video_filters_brightness_label = /** @type {(inputs: Video_Filters_Brightness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brilho`)
};

/**
* | output |
* | --- |
* | "Brightness" |
*
* @param {Video_Filters_Brightness_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_brightness_label = /** @type {((inputs?: Video_Filters_Brightness_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Brightness_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_filters_brightness_label(inputs)
	if (locale === "de") return de_video_filters_brightness_label(inputs)
	if (locale === "it") return it_video_filters_brightness_label(inputs)
	if (locale === "ru") return ru_video_filters_brightness_label(inputs)
	if (locale === "es") return es_video_filters_brightness_label(inputs)
	if (locale === "zh-CN") return zh_cn2_video_filters_brightness_label(inputs)
	if (locale === "ja") return ja_video_filters_brightness_label(inputs)
	if (locale === "hi") return hi_video_filters_brightness_label(inputs)
	if (locale === "pt-PT") return pt_pt2_video_filters_brightness_label(inputs)
	return en_video_filters_brightness_label(inputs)
});